import { Navigate } from 'react-router-dom';
import RoleBasedGuard from '../../../guards/RoleBasedGuard';
import AuthGuardLayout from '../../../components/layouts/AuthGuardLayout';

import { MISC_PATH } from './miscPath';
import { manageUserRoute } from '../manage-user/routes';
import { deliveryMessageRoute } from '../delivery-message/routes';


export const miscRoute = {
  path: 'misc',
  element: <AuthGuardLayout />,
  children: [
    {
      path: '',
      element: <Navigate to={MISC_PATH.MANAGE_USER} replace />,
    },
    manageUserRoute,
    deliveryMessageRoute,
  ],
};
